import type { LayoutSidebarModeGenericProps } from "@/components/Layout/Sidebar/Mode/types";
import type { SupWeb3TxSingleVault } from "@/types";
import React, { useMemo } from "react";

import useGetAdminConfig from "@/hooks/api/useGetAdminConfig";
import { useStoredData } from "@/store/Context";
import useVaults from "@/hooks/api/useVaults";
import Web3Deposit from "@/components/Web3/Deposit";
import Web3CommonCartLoader from "@/components/Web3/Common/Cart/Loader";
import Web3CommonStateDebug from "@/components/Web3/Debug/State";
import Web3CommonCartDisabled from "@/components/Web3/Common/Cart/Disabled";

export default function LayoutSidebarModeDeposit({ className }: LayoutSidebarModeGenericProps) {
  const storedData = useStoredData();

  const { data: adminConfig } = useGetAdminConfig();
  const { data: vaults, isLoading } = useVaults("fully-cached");

  const isDisabled = useMemo(() => {
    return adminConfig?.isDepositDisabled;
  }, [adminConfig]);

  const filteredVaults = useMemo(
    () =>
      (vaults?.filter(vault => storedData.cart.some(item => item === vault.slug)) ?? []).map(
        vault =>
          ({
            ...vault,
            amount: undefined,
            amountInFiat: undefined,
          }) as SupWeb3TxSingleVault
      ),
    [vaults, storedData.cart]
  );

  return isLoading ? (
    <Web3CommonCartLoader />
  ) : isDisabled ? (
    <Web3CommonCartDisabled />
  ) : (
    <Web3CommonStateDebug type="deposit">
      <Web3Deposit vaults={filteredVaults} className={className} />
    </Web3CommonStateDebug>
  );
}
